// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  client: 'evaair',
  production: false,
  stripePublishableKey: 'pk_test_AKFzXNrTAU4SAL1NTUimhbl3',
  stripePublishableKeyTest : 'pk_test_AKFzXNrTAU4SAL1NTUimhbl3',
  paypalClientId: 'ASWolWWmcWqVsTLFo4wdwlURxKGrXJYsWlWXoPzNzkza6apKHo_MkCb65jKoUpWornyGqqGUZTog2g7A',
  paypalClientIdTest: 'ASWolWWmcWqVsTLFo4wdwlURxKGrXJYsWlWXoPzNzkza6apKHo_MkCb65jKoUpWornyGqqGUZTog2g7A',
  siteUrl: 'https://dev-evaair-en.co2analytics.com',
  defaultLanguage: 'en',
  minimumBaseCurrencyAmount: 0.75,
  defaultTabIndex: 1,
  logoImg: {
    name: 'EVAAirLogo.jpg',
    height: '76px',
    width: '186px'
  },
  txOrigins: [
    '*'
  ],
  rxOrigins: [
    '*'
  ],
  partnerConfig: {
    partnerKey: '1f8b994e-8d13-4fbd-b03a-a5d430bf5fc5',
    domain: 'evaair.com'
  },
  apis: {
    domain: 'https://dev-srvc-calculators.co2analytics.com',
    fx: 'https://dev-srvc-ecomm.co2analytics.com/api/v1',
    fin: 'https://dev-srvc-ecomm.co2analytics.com/api/v1',
    version: 'v1.0.0'
  },
  bypassCode: '9YouWontGUeSSTHISoNE43326',
  shareUrl: 'https://www.climateimpact.com/business-solutions/carbon-footprint-calculator',
  componentHierarchy: {
    headerComponents: [
      { templateName: 'calculatorHeaderComponent', componentName: 'CalculatorHeaderComponent' }
    ],
    featureComponents: [
      {
        name: 'start',
        seqn: '0',
        title: 'Quick credit purchase',
        theme: {
          fillColor: '#21536F',
          textClass: 'calculator-selector-text-light'
        },
        component: { templateName: 'startComponent', componentName: 'ClimateCareStartComponent' }
      },
      {
        name: 'flights',
        seqn: '1',
        title: 'Flights',
        theme: {
          fillColor: '#306E8F',
          textClass: 'calculator-selector-text-light'
        },
        component: { templateName: 'flightsComponent', componentName: 'ClimateCareFlightsComponent' }
      }
    ],
    global: [
      {
        component: { defaultFeatureIndex: 0 }
      },
      {
        component: { templateName: 'offsetProjectsComponent', componentName: 'OffsetProjectsComponent' }
      },
      {
        component: { templateName: 'cartComponent', componentName: 'CartComponent' }
      },
      {
        component: { templateName: 'customerDetailsComponent', componentName: 'CustomerDetailsComponent' }
      },
      {
        component: { templateName: 'payOffsetsComponent', componentName: 'PayOffsetsComponent' }
      },
      {
        component: { templateName: 'confirmationComponent', componentName: 'ConfirmationComponent' }
      }
    ],
    footerComponents: [
      { templateName: 'icroaFooterComponent', componentName: 'IcroaFooterComponent' }
    ]
  }
}

// For easier debugging in development mode, you can import the following file
// to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
//
// This import should be commented out in production mode because it will have a negative impact
// on performance if an error is thrown.
//
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
